let baseUrl = "https://feed.premarin.fi";

function initializeFeed() {
  // This is the variable from the feed.
  const feedBoats = premarin_boats;
  const feedEl = document.querySelector("#premarin-feed");
  if (feedBoats.length === 0) return;

  // setup the feed
  feedEl.classList.add("row");

  feedBoats.forEach((e) => {
    const feedItemWrapper = document.createElement("a");
    feedItemWrapper.classList.add(
      "col-lg-3",
      "col-md-6",
      "col-12",
      "feed-item"
    );
    // Base feed item element
    const feedItem = document.createElement("div");
    feedItem.classList.add("d-flex", "flex-column", "feed-item-wrapper");
    feedItemWrapper.href = "https://nettivene.fi/" + e.id;
    feedItemWrapper.target = "_blank";
    feedItemWrapper.appendChild(feedItem);

    // Item title
    const itemTitle = document.createElement("h3");
    itemTitle.textContent =
      (e.make !== "Muu merkki" ? e.make + " " : "") + e.model;

    const itemInfo = document.createElement("div");
    itemInfo.classList.add("d-flex", "item-info");

    const itemType = document.createElement("p");
    itemType.textContent = e.boatType + ", " + e.year;

    const itemPrice = document.createElement("p");
    itemPrice.textContent = e.price + "€";

    itemInfo.appendChild(itemType);
    itemInfo.appendChild(itemPrice);

    // Item image
    const itemImage = document.createElement("img");
    itemImage.classList.add("item-image", "w-100");
    itemImage.src = baseUrl + "/images/" + e.id + ".jpg";
    feedItem.appendChild(itemTitle);
    feedItem.appendChild(itemInfo);
    feedItem.appendChild(itemImage);
    feedEl.appendChild(feedItemWrapper);
  });
}

// Dynamically inserting the boat.
window.addEventListener("load", (event) => {
  if (!document.querySelector("#premarin-feed")) return;

  let boatFeed = document.createElement("script"),
    head = document.head || document.getElementsByTagName("head")[0];
  boatFeed.src = baseUrl + "/boats.js";
  boatFeed.async = false;
  head.insertBefore(boatFeed, head.firstChild);

  boatFeed.addEventListener("load", initializeFeed);
});
